export const getDepartments = (
  departments: {
    label: string;
    value: string;
  }[],
  item: {
    label: string;
    value: string;
  },
) => {
  const exists = departments?.some((el) => el.value === item?.value);

  return exists ? departments : [...(departments ?? []), item];
};
